import React, { Fragment, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { injectIntl } from 'react-intl';
import { Link } from 'react-router-dom';
import _ from 'lodash';

import Paper from '@material-ui/core/Paper';
import { getPropertType, getPropertyThumbnail } from 'aurora-utils/utils';
import { enKeys, arKeys } from './langKeys';

import Thumbnail from './thumb';
import ContentBox from './contentBox';
import Actions from './actions';
import styles from './styles';

function OwnershipPropertyCard(props) {
  const { classes, property, isLink, to } = props;
  const propertyType = getPropertType(property?.propertyType);

  let title = '';

  // localization
  const lang = localStorage.getItem('lang');
  const [langKeys, setlangKeys] = useState({});

  useEffect(() => {
    // set langKeys
    if (lang === 'en') {
      setlangKeys(enKeys);
    } else {
      setlangKeys(arKeys);
    }
  }, [lang]);

  if (propertyType === 'Land') {
    title = _.get(property, `${langKeys.plotNumber}`) + ',' + _.get(property, `${langKeys.commUnityName}`);
  } else if (propertyType === 'Unit') {
    title = _.get(property, `${langKeys.unitNumber}`) + ', ' + _.get(property, `${langKeys.commUnityName}`);
  } else if (propertyType === 'Building') {
    title = _.get(property, `${langKeys.buildingNumber}`) + ', ' + _.get(property, `${langKeys.commUnityName}`);
  } else if (propertyType === 'Villa') {
    title = _.get(property, `${langKeys.buildingNumber}`) + ', ' + _.get(property, `${langKeys.buildingName}`);
  } else {
    title = _.get(property, `${langKeys.plotNumber}`) + ',' + _.get(property, `${langKeys.commUnityName}`);
  }

  const content = [
    { title: 'Name', value: title }, // _.get(property, `${langKeys.buildingName}`) },
    { title: 'Road', value: _.get(property, `${langKeys.roadName}`) },
    { title: 'Municipality', value: _.get(property, `${langKeys.municipalityName}`) },
    { title: 'District', value: _.get(property, `${langKeys.districtName}`) },
    {
      title: 'Area',
      value: propertyType === 'Land' ? `${_.get(property, 'estimatedArea')} sm` : `${_.get(property, 'unitarea')} sm`,
    },
  ];

  const renderCard = (
    <Paper elevation={2} className={classes.leasecardItem}>
      <sup className={classes.badge}>{propertyType}</sup>
      <div className={classes.contentContainer}>
        <Thumbnail image={getPropertyThumbnail(propertyType, 'ownership')} title='Property Thumb' />

        <div className={classes.detailsHolder}>
          {content.map(
            (item, i) =>
              item.value && (
                <ContentBox
                  key={item.value}
                  title={item.title}
                  value={item.value}
                  boldTitle={item.title === 'Name'}
                  isFirst={i === 0}
                />
              ),
          )}
        </div>
      </div>

      <Actions
        data={[
          { text: property.ownershipType, color: 'info' },
          { text: property.state, color: property.state === 'Vacant' ? 'success' : 'warning' },
        ]}
      />
    </Paper>
  );

  if (isLink) {
    return (
      <Link className={classes.link} to={to}>
        {renderCard}
      </Link>
    );
  }

  return <Fragment>{renderCard}</Fragment>;
}

OwnershipPropertyCard.propTypes = {
  classes: PropTypes.object.isRequired,
  property: PropTypes.object.isRequired,
  isLink: PropTypes.bool,
  to: PropTypes.string,
};

OwnershipPropertyCard.defaultProps = {
  isLink: false,
  to: '',
};

export default withStyles(styles)(injectIntl(OwnershipPropertyCard));
